import { render } from "./ComplianceDocs.vue?vue&type=template&id=611e6c6d&scoped=true"
import script from "./ComplianceDocs.vue?vue&type=script&lang=js"
export * from "./ComplianceDocs.vue?vue&type=script&lang=js"

import "./ComplianceDocs.vue?vue&type=style&index=0&id=611e6c6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611e6c6d"]])

export default __exports__